module.exports = __webpack_public_path__ + "static/media/Priscilla Gil_1681700763748.83afeb2e.jpeg";